import { RootState } from "../../store";
import { resourceExplorerChartSettingsSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/chart/settings/resourceExplorerChartSettingsSelector";

export const resourceExplorerChartBaseSelector = (state: RootState) => {
  const data = resourceExplorerChartSettingsSelector(state);

  return data?.chart_base_type ?? "cost";
};
